if (!customElements.get('eu-compliance-checklist')) {
  customElements.define('eu-compliance-checklist', class EuComplianceChecklist extends HTMLElement {
    connectedCallback() {
      this.storageKey = this.dataset.storageKey || 'eu-compliance-checklist';
      this.clientId = this.dataset.client;

      this.scoreEl = this.querySelector('.eu-checklist-score__count');
      this.summaryEl = this.querySelector('.eu-checklist-summary');
      this.resetBtn = this.querySelector('.eu-checklist-reset');
      this.items = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

      this._onChange = this.handleChange.bind(this);
      this._onReset = this.handleReset.bind(this);

      this.restoreAnswers();
      this.appendClientParam();

      this.addEventListener('change', this._onChange);
      this.resetBtn?.addEventListener('click', this._onReset);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this._onChange);
      this.resetBtn?.removeEventListener('click', this._onReset);
    }

    restoreAnswers() {
      try {
        const saved = JSON.parse(localStorage.getItem(this.storageKey) || '{}');
        for (const [name, value] of Object.entries(saved)) {
          const radio = this.querySelector(`input[name="${name}"][value="${value}"]`);
          if (radio) radio.checked = true;
        }
      } catch (_) {}
      this.updateScore();
    }

    appendClientParam() {
      if (!this.clientId) return;
      const url = new URL(window.location.href);
      if (!url.searchParams.has('client')) {
        url.searchParams.set('client', this.clientId);
        history.replaceState(null, '', url.toString());
      }
    }

    handleChange() {
      const answers = {};
      for (const item of this.items) {
        const checked = this.querySelector(`input[name="item-${item}"]:checked`);
        if (checked) answers[`item-${item}`] = checked.value;
      }
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(answers));
      } catch (_) {}
      this.updateScore();
      this.updateItemStates();
    }

    updateScore() {
      let answered = 0;
      let yesCount = 0;

      for (const item of this.items) {
        const checked = this.querySelector(`input[name="item-${item}"]:checked`);
        if (checked) {
          answered++;
          if (checked.value === 'yes') yesCount++;
        }
      }

      if (this.scoreEl) this.scoreEl.textContent = answered;

      if (answered === 8) {
        this.showSummary(yesCount);
      } else {
        if (this.summaryEl) this.summaryEl.hidden = true;
      }
    }

    updateItemStates() {
      for (const item of this.items) {
        const el = this.querySelector(`.eu-checklist-item[data-item="${item}"]`);
        const checked = this.querySelector(`input[name="item-${item}"]:checked`);
        if (el) {
          el.dataset.answered = checked ? checked.value : '';
        }
      }
    }

    showSummary(yesCount) {
      if (!this.summaryEl) return;
      this.summaryEl.hidden = false;

      const ranges = this.summaryEl.querySelectorAll('[data-range]');
      ranges.forEach(r => r.hidden = true);

      let range = 'low';
      if (yesCount === 8) range = 'high';
      else if (yesCount >= 5) range = 'mid';

      const active = this.summaryEl.querySelector(`[data-range="${range}"]`);
      if (active) active.hidden = false;

      this.summaryEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    handleReset() {
      try {
        localStorage.removeItem(this.storageKey);
      } catch (_) {}

      this.querySelectorAll('input[type="radio"]').forEach(r => r.checked = false);

      this.items.forEach(item => {
        const el = this.querySelector(`.eu-checklist-item[data-item="${item}"]`);
        if (el) el.dataset.answered = '';
      });

      if (this.scoreEl) this.scoreEl.textContent = '0';
      if (this.summaryEl) this.summaryEl.hidden = true;
    }
  });
}
